const fee = [{
  path: 'fee/index',
  component: resolve => require(['../../../../components/pages/user/fee'], resolve)
}, {
  path: 'fee/onlinePayment/:itemId',
  props: true,
  component: resolve => require(['../../../../components/pages/user/fee/FeeOnlinePayment'], resolve)
}, {
  path: 'fee/onlineStubPayment/:itemId',
  props: true,
  component: resolve => require(['../../../../components/pages/user/fee/FeeOnlineStubPayment'], resolve)
}, {
  path: 'fee/paymentOrder/:orderId',
  props: true,
  component: resolve => require(['../../../../components/pages/user/fee/FeePaymentOrder'], resolve)
}, {
  path: 'fee/orderSuccess/:orderId',
  props: true,
  component: resolve => require(['../../../../components/pages/user/fee/FeeOrderSuccess'], resolve)
}, {
  path: 'fee/paymentRecord',
  component: resolve => require(['../../../../components/pages/user/fee/FeePaymentRecord'], resolve)
}]
export default fee
